import ManageApps from './containers/ManageAppsContainer';
export default ManageApps;